import React from "react";
import { useCharacter } from "../../../hooks/use-character";
import Field from "../../ui/Field";

interface Props {
  className?: string;
}

const Hair: React.FC<Props> = ({ className }) => {
  const {
    mode,
    handleHairChange,
    character: {
      hair: { hairstyle, eyebrows, haircolor },
    },
  } = useCharacter();

  return (
    <div className={`space-y-8 ${className}`}>
      {/** Hairstyle */}
      <Field
        label="Frizură"
        description="Alege stilul părului"
        type="stepper"
        initialValue={hairstyle}
        min={0}
        max={10}
        onChange={(value) => handleHairChange({ hairstyle: Number(value) })}
      />

      {/**  Eyebrowns */}
      <Field
        label="Sprancene"
        description="Alege forma sprâncenelor"
        type="stepper"
        initialValue={eyebrows}
        min={0}
        max={34}
        onChange={(value) => handleHairChange({ eyebrows: Number(value) })}
      />

      {/**  Haircolor */}
      <Field
        label="Culoarea Părului'"
        description="Alege culoarea părului"
        type="stepper"
        initialValue={haircolor}
        min={0}
        max={64}
        onChange={(value) => handleHairChange({ haircolor: Number(value) })}
      />
    </div>
  );
};

export default Hair;
